import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template97: Consejos NY (guia-ny Tips). Contenido desde page (texts, tips, images).
const Template97 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";
	const p = {
		fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const headerText =
		page?.texts?.[0]?.content ?? "Consejos útiles para Nueva York";
	const introText = page?.texts?.[1]?.content;
	const tips = Array.isArray(page?.tips)
		? page.tips
		: Array.isArray(page?.data?.tips)
			? page.data.tips
			: Array.isArray(page?.data?.data?.tips)
				? page.data.data.tips
				: [];
	const sticker1 = getImageSrc("consejos");
	const sticker2 = getImageSrc("enchufe");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: fontFamily || '"Poppins", sans-serif',
				"& *:not([data-template-header])": {
					fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
					color: "inherit",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
			</div>
			{introText && (
				<div data-block-id="text-1" style={{ padding: "16px", fontSize: 13, color: contentColor }}>
					<p style={p}>{introText}</p>
				</div>
			)}
			<div
				data-block-id="text-2"
				style={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 12,
					position: "relative",
				}}
			>
				{tips.map((tip, i) => (
					<div
						key={tip.texto || i}
						style={{
							backgroundColor: "#fff",
							borderRadius: 12,
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: 10,
							border: "2px solid #e0f7fa",
							...(isSmallScreen && i === 1 && { marginRight: 16 }),
						}}
					>
						{tip.icono && <div style={{ fontSize: 18 }}>{tip.icono}</div>}
						<div style={{ fontSize: 13, color: contentColor }}>
							{typeof tip.texto === "string" &&
							/<[a-z][\s\S]*>/i.test(tip.texto) ? (
								<span dangerouslySetInnerHTML={{ __html: tip.texto }} />
							) : (
								<>{tip.texto}</>
							)}
						</div>
					</div>
				))}
				{sticker1 && (
					<img
						src={sticker1}
						alt=""
						style={{
							width: isSmallScreen ? 89 : 90,
							position: "absolute",
							top: isSmallScreen ? 120 : 0,
							right: isSmallScreen ? -30 : -20,
						}}
					/>
				)}
				{sticker2 && (
					<img
						src={sticker2}
						alt=""
						style={{
							width: 80,
							position: "absolute",
							bottom: isSmallScreen ? -60 : -20,
							right: -10,
						}}
					/>
				)}
			</div>
		</Box>
	);
};

export default Template97;
